import PropTypes from "prop-types";
import InputBase from "./InputBase";
import {InputAdornment, TextField} from "@mui/material";
import {Search} from "@mui/icons-material";

class InputSearch extends InputBase {

  constructor(props) {
    super(props);
    this.state.iconColor = '';
  }

  getValue() {
    return this.inputElementRef.current.value;
  }

  clear() {
    this.inputElementRef.current.value = '';
  }

  render() {

    return <TextField
      size='small'
      variant='standard'
      onFocus={(e) => this.setState({iconColor: 'primary'})}
      onBlur={(e) => this.setState({iconColor: ''})}
      inputRef={this.inputElementRef}
      placeholder={this.props.placeholder}
      defaultValue={this.props.defaultValue}
      onChange={(e) => this.fireOnChange(e)}
      slotProps={{
        input: {
          startAdornment: (<InputAdornment position="start">
            <Search color={this.state.iconColor}/>
          </InputAdornment>),
        },
      }}
    />

  }
}

InputSearch.propTypes = {
  className: PropTypes.string,
  iconLeft: PropTypes.node,
  iconRight: PropTypes.node,
  labelElement: PropTypes.any,
  helpTextElement: PropTypes.node,
  state: PropTypes.oneOf(['none', 'enable', 'disable', 'error', 'readonly']),
  inputLayout: PropTypes.oneOf(['inline', 'outline', '']),
  defaultValue: PropTypes.any,
  onChange: PropTypes.func,
  placeholder: PropTypes.string
}
export default InputSearch;